// import { Button, Nav, NavItem } from "reactstrap";
// import Logo from "./Logo";
// import { Link, useLocation } from "react-router-dom";
// import getPrivilegeList from "../peday/PrivilegeList";

// const navigation = [
//   {
//     title: "Dashboard",
//     href: "/Dashboard",
//     icon: "bi bi-speedometer2",
//     // no privilege key → always visible
//   },
//   {
//     title: "Customer",
//     href: "/CustomerList",
//     icon: "bi bi-people",
//     privilegeKey: "customerTabView",
//   },
//   {
//     title: "Loan",
//     href: "/LoanList",
//     icon: "bi bi-cash-stack",
//     privilegeKey: "loanTabView",
//   },
//   {
//     title: "Collection",
//     href: "/CollectionList",
//     icon: "bi bi-wallet2",
//     privilegeKey: "collectionTabView",
//   },
//   {
//     title: "Disbursment",
//     href: "/DisbursementList",
//     icon: "bi bi-bank",
//     privilegeKey: "disbursementTabView",
//   },
//   {
//     title: "Employees",
//     href: "/EmployeeList",
//     icon: "bi bi-person-badge",
//     privilegeKey: "employeeTabView",
//   },
//   {
//     title: "Credit Under Writing",
//     href: "/CreditUnderWriting",
//     icon: "bi bi-journal-check",
//     privilegeKey: "creditTabView",
//   },
//   {
//     title: "OverDue",
//     href: "/OverDueList",
//     icon: "bi bi-exclamation-circle",
//     privilegeKey: "overDewTabView",
//   },
//   {
//     title: "Today Emi Schedule",
//     href: "/TodayEmiSchedule",
//     icon: "bi bi-calendar-check",
//     privilegeKey: "todayEmiTabView",
//   },
//     {
//     title: "Payment",
//     href: "/Payment",
//      icon: "bi bi-credit-card",
//     privilegeKey: "paymentTabView",
//   },
//    {
//     title: "LoginFee",
//     href: "/LoginFee",
//      icon: "bi bi-wallet2",
//     privilegeKey: "LoginTabView",
//   },
//   {
//     title: "Product",
//     href: "/ProductList",
//     icon: "bi bi-box-seam",
//     privilegeKey: "productTabView",
//   },
//     {
//     title: "UPI Autopay",
//     href: "/MandateRegistration",
//     icon: "bi bi-credit-card",
//     privilegeKey: "MandateRegistrationView",
//   },
//   {
//     title: "Reject",
//     href: "/RejectLoanList",
//     icon: "bi bi-x-circle",
//     privilegeKey: "rejectTabView",
//   },
//     {
//     title: "EmiCalculator",
//     href: "/EmiCalculator",
//     icon:"bi bi-calculator",
//     privilegeKey: "emiCalculateTabView",
//   },
//    {
//     title: "CallerRemarks",
//     href: "/CollectionCallerRemarks",
//     icon: "bi bi-journal-text",
//     privilegeKey: "CallerTabView",
//   },

// ];

// const Sidebar = () => {
//   const showMobilemenu = () => {
//     document.getElementById("sidebarArea").classList.toggle("showSidebar");
//   };

//   let location = useLocation();
//   const privilege = getPrivilegeList(); 

//   return (
//     <div className="p-3 sidebarfixed">
//       <div className="d-flex align-items-center">
//         <Logo />
//         <span className="ms-auto d-lg-none">
//           <Button
//             close
//             size="sm"
//             className="ms-auto d-lg-none"
//             onClick={() => showMobilemenu()}
//           ></Button>
//         </span>
//       </div>
//       <div className="pt-4 mt-2">
//         <Nav vertical className="sidebarNav">
//           {navigation.map((navi, index) => {
//             // 👇 hide if privilegeKey exists and user doesn’t have it
//             if (navi.privilegeKey && !privilege[navi.privilegeKey]) {
//               return null;
//             }
//             return (
//               <NavItem key={index} className="sidenav-bg">
//                 <Link
//                   to={navi.href}
//                   className={
//                     location.pathname === navi.href
//                       ? "text-primary nav-link py-3"
//                       : "nav-link text-secondary py-3"
//                   }
//                 >
//                   <i className={navi.icon}></i>
//                   <span className="ms-3 d-inline-block">{navi.title}</span>
//                 </Link>
//               </NavItem>
//             );
//           })}
//         </Nav>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import { Button, Nav, NavItem, Collapse } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import getPrivilegeList from "../peday/PrivilegeList";

/* =======================
   MENU CONFIG
======================= */
const navigation = [
  {
    title: "Dashboard",
    href: "/Dashboard",
    icon: "bi bi-speedometer2",
  },
  {
    title: "Customer",
    href: "/CustomerList",
    icon: "bi bi-people",
    privilegeKey: "customerTabView",
  },

  /* ===== LOAN ACCOUNT ===== */
  {
    title: "Loan Account",
    icon: "bi bi-bank2",
    privilegeKey: "loanTabView",
    type: "dropdown",
    children: [
      {
        title: "Loan",
        href: "/LoanList",
        icon: "bi bi-cash-stack",
        privilegeKey: "loanTabView",
      },
      {
        title: "Disbursement",
        href: "/DisbursementList",
        icon: "bi bi-bank",
        privilegeKey: "disbursementTabView",
      },
      {
        title: "Reject",
        href: "/RejectLoanList",
        icon: "bi bi-x-circle",
        privilegeKey: "rejectTabView",
      },
    ],
  },

  /* ===== REPAYMENT ===== */
  {
    title: "Repayment",
    icon: "bi bi-wallet2",
    privilegeKey: "collectionTabView",
    type: "dropdown",
    children: [
      {
        title: "Collection",
        href: "/CollectionList",
        icon: "bi bi-wallet2",
        privilegeKey: "collectionTabView",
      },
      {
        title: "Today EMI Schedule",
        href: "/TodayEmiSchedule",
        icon: "bi bi-calendar-check",
        privilegeKey: "todayEmiTabView",
      },

       {
    title: "OverDue",
    href: "/OverDueList",
    icon: "bi bi-exclamation-circle",
    privilegeKey: "overDewTabView",
  },
     
      {
        title: "Login Fee",
        href: "/LoginFee",
        icon: "bi bi-currency-rupee",
        privilegeKey: "LoginTabView",
      },
    ],
  },

  /* ===== NORMAL MENUS ===== */
  {
    title: "Access Management",
    href: "/EmployeeList",
    icon: "bi bi-shield-lock",
    privilegeKey: "employeeTabView",
  },
  //   {
  //   title: "Company",
  //   href: "/Company",
  //   icon: "bi bi-person-badge",
  //   privilegeKey: "companyTabView",
  // },
  //   {
  //   title: "Branch",
  //   href: "/Branch",
  //   icon: "bi bi-person-badge",
  //   privilegeKey: "branchTabView",
  // },
  //     {
  //   title: "Agent",
  //   href: "/Agent",
  //   icon: "bi bi-person-badge",
  //   privilegeKey: "agentTabView",
  // },
        {
    title: "Finance Users",
    href: "/User",
    icon: "bi bi-shop",
    privilegeKey: "agentTabView",
  },

          {
    title: "Wallet",
    href: "/Wallet",
    icon: "bi bi-cash-stack",
    privilegeKey: "walletTabView",
  },

   {
      title: "Payment",
      href: "/Payment",
      icon: "bi bi-credit-card",
      privilegeKey: "paymentTabView",
   },

  {
    title: "Credit Under Writing",
    href: "/CreditUnderWriting",
    icon: "bi bi-journal-check",
    privilegeKey: "creditTabView",
  },
 
  {
    title: "Product",
    href: "/ProductList",
    icon: "bi bi-box-seam",
    privilegeKey: "productTabView",
  },
  {
    title: "UPI AutoPay",
    href: "/MandateRegistration",
    icon: "bi bi-credit-card",
    privilegeKey: "MandateRegistrationView",
  },

  /* ✅ MISSED — NOW ADDED */
  {
    title: "EMI Calculator",
    href: "/EmiCalculator",
    icon: "bi bi-calculator",
    privilegeKey: "emiCalculateTabView",
  },
  {
    title: "Caller Remarks",
    href: "/CollectionCallerRemarks",
    icon: "bi bi-journal-text",
    privilegeKey: "CallerTabView",
  },
];

/* =======================
   SIDEBAR COMPONENT
======================= */
const Sidebar = () => {
  const location = useLocation();
  const privilege = getPrivilegeList();
  const [openMenu, setOpenMenu] = useState(null);

  const showMobilemenu = () => {
    document.getElementById("sidebarArea")?.classList.toggle("showSidebar");
  };

  /* Auto open dropdown on active child */
  useEffect(() => {
    navigation.forEach((item, index) => {
      if (
        item.type === "dropdown" &&
        item.children.some((c) => c.href === location.pathname)
      ) {
        setOpenMenu(index);
      }
    });
  }, [location.pathname]);

  return (
    <div className="sidebarfixed d-flex flex-column h-100 p-3">
      {/* HEADER */}
      <div className="d-flex align-items-center mb-3">
        <Logo />
        <span className="ms-auto d-lg-none">
          <Button close size="sm" onClick={showMobilemenu} />
        </span>
      </div>

      {/* NAV */}
      <Nav vertical className="sidebarNav">
        {navigation.map((item, index) => {
          /* DROPDOWN */
          if (item.type === "dropdown") {

  // ✅ Filter children based on privilege
  const visibleChildren = item.children.filter(
    (child) => !child.privilegeKey || privilege[child.privilegeKey]
  );

  // ❌ If no children visible → hide dropdown
  if (visibleChildren.length === 0) return null;

  const isActive = visibleChildren.some(
    (c) => c.href === location.pathname
  );

  return (
    <NavItem key={index} className="sidenav-bg">
      <button
        type="button"
        className={`nav-link py-3 w-100 d-flex align-items-center border-0 bg-transparent ${
          isActive ? "text-primary" : "text-secondary"
        }`}
        onClick={() =>
          setOpenMenu(openMenu === index ? null : index)
        }
      >
        <i className={item.icon}></i>
        <span className="ms-3 flex-grow-1">{item.title}</span>
        <i
          className={`bi ${
            openMenu === index ? "bi-chevron-up" : "bi-chevron-down"
          }`}
        ></i>
      </button>

      <Collapse isOpen={openMenu === index}>
        <Nav vertical className="ps-4">
          {visibleChildren.map((child, i) => (
            <NavItem key={i}>
              <Link
                to={child.href}
                className={`nav-link py-2 d-flex align-items-center ${
                  location.pathname === child.href
                    ? "text-primary"
                    : "text-secondary"
                }`}
              >
                <i className={child.icon}></i>
                <span className="ms-2">{child.title}</span>
              </Link>
            </NavItem>
          ))}
        </Nav>
      </Collapse>
    </NavItem>
  );
}
       
          /* NORMAL ITEM */
          if (item.privilegeKey && !privilege[item.privilegeKey]) return null;

          return (
            <NavItem key={index} className="sidenav-bg">
              <Link
                to={item.href}
                className={`nav-link py-3 d-flex align-items-center ${
                  location.pathname === item.href
                    ? "text-primary"
                    : "text-secondary"
                }`}
              >
                <i className={item.icon}></i>
                <span className="ms-3">{item.title}</span>
              </Link>
            </NavItem>
          );
        })}
      </Nav>
    </div>
  );
};

export default Sidebar;